import { ListActions } from 'react-use/lib/useList';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { ImageWithFallback } from '@qb/frontend/components/ImageWithFallback';
import { NumberInput } from '@qb/frontend/components/NumberInput/NumberInput';
import { clampLinesSx } from '@qb/frontend/utils/clampLinesSx';
import { formatDollars } from '@qb/frontend/utils/formatCurrency';
import { PartWithQty } from '@/src/components/Dashboards/components/CreateNewQuoteDrawer/CreateNewQuoteDrawer';
import { useTenantAlias } from '@/src/hooks/useTenantAlias';
type RequestedPartProps = {
  part: PartWithQty;
  index: number;
  selectedPartsListActions: ListActions<PartWithQty>;
  isOrderFlow?: boolean;
};
export const RequestedPart = ({
  part,
  index,
  selectedPartsListActions,
  isOrderFlow = false
}: RequestedPartProps) => {
  const tenantAlias = useTenantAlias();
  return <Stack direction="row" spacing={2} sx={{
    alignItems: 'flex-start'
  }} data-sentry-element="Stack" data-sentry-component="RequestedPart" data-sentry-source-file="RequestedPart.tsx">
      <ImageWithFallback tenantAlias={tenantAlias} src={part.images[0]?.target} alt={part.partNumber} width={50} height={50} data-sentry-element="ImageWithFallback" data-sentry-source-file="RequestedPart.tsx" />
      <Box data-sentry-element="Box" data-sentry-source-file="RequestedPart.tsx">
        <Typography variant="h6" data-sentry-element="Typography" data-sentry-source-file="RequestedPart.tsx">{part.partNumber}</Typography>
        <Typography variant="bodyMediumPrimary" sx={{
        color: 'text.secondary'
      }} data-sentry-element="Typography" data-sentry-source-file="RequestedPart.tsx">
          {part.manufacturer.name}
        </Typography>
        {isOrderFlow && part.price !== undefined && <Typography variant="bodyMediumPrimary" color="primary.main" mt={0.5}>
            {formatDollars(part.price)}
          </Typography>}
      </Box>
      <Typography variant="bodyMedium" sx={{
      color: 'text.secondary',
      flex: 1,
      ...clampLinesSx(3)
    }} data-sentry-element="Typography" data-sentry-source-file="RequestedPart.tsx">
        {part.description}
      </Typography>
      <Stack direction="row" spacing={1} sx={{
      alignItems: 'flex-end'
    }} data-sentry-element="Stack" data-sentry-source-file="RequestedPart.tsx">
        <Stack spacing={1} data-sentry-element="Stack" data-sentry-source-file="RequestedPart.tsx">
          <Typography variant="bodyMedium" data-sentry-element="Typography" data-sentry-source-file="RequestedPart.tsx">QTY</Typography>
          <NumberInput initialValue={part.qty} onValueChange={newValue => {
          if (newValue !== part.qty) {
            selectedPartsListActions.updateAt(index, {
              ...part,
              qty: newValue
            });
          }
        }} data-sentry-element="NumberInput" data-sentry-source-file="RequestedPart.tsx" />
        </Stack>
        <IconButton color="primary" size="small" onClick={() => selectedPartsListActions.removeAt(index)} data-sentry-element="IconButton" data-sentry-source-file="RequestedPart.tsx">
          <DeleteIcon data-sentry-element="DeleteIcon" data-sentry-source-file="RequestedPart.tsx" />
        </IconButton>
      </Stack>
    </Stack>;
};